import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ServiceConfig} from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class RoleService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/role/';
  // public baseUrl = 'http://localhost/api/role/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public create(body) {
    let url = this.baseUrl + 'create?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
  
  public update(id: String, body) {
    let url = this.baseUrl + id + '/update?token=' + this.data.token;
    console.log(url);
    return this.http.post<any>(url, body);
  }

  // TÌM ACCOUNTS ĐANG GÁN ROLE THEO ID
  public findAccountAssignedRole(id: String, body) {
    let url = this.baseUrl + id + '/findAccountAssignedRole?token=' + this.data.token;
     //console.log(url);
    return this.http.post<any>(url, body);
  }

  public delete(id: String, body) {
    let url = this.baseUrl + id + '/delete?token=' + this.data.token;
    // console.log(url);
    return this.http.post<any>(url, body);
  }

  public updateMany(body){
    let url = this.baseUrl + '/updateMany?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  // badv: lấy tất cả các roles có chứa permission 
  public findRolesByPermission(permissionId: String){
    let url = this.baseUrl + permissionId + '/findRolesByPermission?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, this.options);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/role.service.ts